import { render, staticRenderFns } from "./Adhoc_pendingvehicle.vue?vue&type=template&id=9d610e2a&scoped=true"
import script from "./Adhoc_pendingvehicle.vue?vue&type=script&lang=js"
export * from "./Adhoc_pendingvehicle.vue?vue&type=script&lang=js"
import style0 from "./Adhoc_pendingvehicle.vue?vue&type=style&index=0&id=9d610e2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d610e2a",
  null
  
)

export default component.exports